<template>
    <base-frame :isMe="isMe" noBorderBottomRadius>
      <div slot="chatmessage" v-html="msgObj.content || str" ref="beforeCall">

      </div>
      <div
        slot="otherMsg"
        class="call"
        @click="call"
		:disabled="calling != 0" :style="callstyle">
          转接人工客服
      </div>
	  <!-- :disabled="calling != 0" :style="{width:msgObj.content?(msgObj.content=='点击转接人工客服，专业人工客服为您服务'?'58.1%':'89.4%'):'99.6%'}"> -->
    </base-frame>
</template>

<script>
import {mapGetters} from 'vuex'
import BaseFrame from './BaseFrame'

export default {
  name: 'tpl-to-customer',
  components: {
    BaseFrame
  },
  data() {
    return {
      str: '亲，您好！我是机器人小天~您可以用一句话描述您的问题，例如：什么是活期宝？<br>回复"人工客服"或点击下方文字可转接人工客服~',
      callstyle:{
        width:($(this.$refs.beforeCall).width() + 20 ) + 'px',
      },
    }
  },
  mounted(){
	  this.$nextTick(() => {
		  this.callstyle.width = ($(this.$refs.beforeCall).width() + 20 ) + 'px'
	  })
  },
  watch: {
    msgObj() {
      this.$nextTick(() => {
        this.callstyle.width = ($(this.$refs.beforeCall).width() + 20 ) + 'px'
      })
    }
  },
  props: {
    msgObj: Object,
    isMe: Boolean
  },
  computed: {
    ...mapGetters({
      calling: 'calling'
    })
  },
  methods: {
    call () {
      Bus.$emit("applyLineup");
    }
  }
}
</script>

<style scoped>
.chatmessage {
  border-bottom: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.call {
  color: #088aff;
  text-align: center;
  line-height: 40px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  background-color: #fff;
  font-size: 14px;
  /* width:58.5%; */
  cursor: pointer;
	border: 1px solid #e5e5e5;
  border-top: none;
  user-select: none;
  /* border-top: 1px solid #efefef; */
}
</style>





// WEBPACK FOOTER //
// src/components/templates/TplToCustomer.vue